export default __webpack_public_path__ + "static/media/CoinsDrop.93e3f1f8.wav";